module.exports = __webpack_public_path__ + "static/media/stop-circle.f802172b.svg";